import { render, staticRenderFns } from "./HeaderSettings.vue?vue&type=template&id=4010b5fe"
import script from "./HeaderSettings.vue?vue&type=script&lang=js"
export * from "./HeaderSettings.vue?vue&type=script&lang=js"
import style0 from "./HeaderSettings.vue?vue&type=style&index=0&id=4010b5fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports